export default {
    layoutOptions: [
        {
            label: 'Stående',
            value: 'vertical'
        },
        {
            label: 'Liggande',
            value: 'horizontal'
        }
    ],
    sizeOptions: [
        {
            label: 'A4',
            value: 'a4',
        },
        {
            label: '30x40cm',
            value: '30x40cm',
        },
        {
            label: '50x70cm',
            value: '50x70cm',
        },
    ],
    presets: [
        {
            label: 'Sverige',
            value: 'sverige',
        },
        {
            label: 'Europa',
            value: 'europa1',
        },
        {
            label: 'Norden',
            value: 'europa2',
        },
        {
            label: 'Världen',
            value: 'varlden',
        },
    ],
    mapStyles: [
        {
            label: 'Osm',
            value: 'osm',
        },
        {
            label: 'Lovemap',
            value: 'lovemap',
        },
        {
            label: 'City-map',
            value: 'cityMap',
        },
    ],
    language: [
        {
            label: 'Svenska',
            value: 'sw',
        },
        {
            label: 'Engelska',
            value: 'en',
        },
        {
            label: 'Spanska',
            value: 'es',
        },
    ],
}